










































































import VueOptions from '@utils/VueOptions'
import FormField from '@ui/FormBuilder/FormField'
import Editor from '@/components/Editor'

settings =
  name: 'VendorListingForm'

  resources:
    supplier:
      resourceName: 'supplier'
      slug: 'suppliers/:item.supplier_id'

    media_kits:
      resourceName: 'media_kit'
      slug: 'media_kit'

  vue:
    props: ['item', 'mode']

    components: {
      FormField,
      Editor,
    }

    mounted: ->
      @item.owner_id ||= @$route.query.organizerId
      @item.supplier_id ||= @$route.query.supplierId

    computed:
      serviceTypes: -> [
        { name: "Other" , type: "other" }
        { name: "Printing" , type: "printing" }
        { name: "Shipping" , type: "shipping" }
        { name: "Staffing" , type: "staffing" }
        { name: "Custom fabrication" , type: "custom_fabrication" }
        { name: "Redemption program receipt scanning" , type: "redemption_scanning" }
        { name: "Digital Media" , type: "digital_media" }
      ]

      inputPropsForImages: ->
        options: @media_kits?.media || []

    methods:
      fetchMediaKits: ->
        @fetch 'media_kits'

export default VueOptions.vue settings
